import { Button, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllOrderedServiceForManagement } from "../../services/servicesServices.js";
import ServiceImage from "./additionFields/ServiceImage.jsx";
import ConstructionStatus from "./additionFields/ConstructionStatus.jsx";
import Contractor from "./additionFields/Contractor.jsx";
import Payment from "./additionFields/Payment.jsx";
import PaymentIcon from '@mui/icons-material/Payment';
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { base_api_url } from "../../services/httpService.js";
import { DownloadRounded, Payments, QuestionAnswer } from "@mui/icons-material";
import { fileDownloaderWithName, fileDownloaderWithoutFormat } from "../../utils/fileDownloader.js";
import ManagerDetail from "./additionFields/ManagerDetail.jsx";
import QualityControl from "./additionFields/QualityControl.jsx";
import ContractorAssignment from "./additionFields/ContractorAssignment.jsx";
import Alert from "../../utils/Alert.js";
import swal from "sweetalert";
import { accountSettlementService } from "../../services/usersServices.js";
import Visibility from "./additionFields/Visibility.jsx";

const options = [
  {
    text: "همه سرویس‌ها",
    value: "",
  },
  {
    text: "در انتظار اختصاص پیمانکار",
    value: "o",
  },
  {
    text: "در حال ساخت",
    value: "u",
  },
  {
    text: "کنترل کیفیت",
    value: "q",
  },
  {
    text: "در انتظار تسویه",
    value: "a",
  },
];

const ManageContractorServicePage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const navigate = useNavigate();

  const accountSettlement = async (code) => {
    try {
      const response = await accountSettlementService(code);
      if (response.status === 200) {
        window.location.reload()
      }
    }catch (error) {
      Alert("خطا!", "در تسویه حساب مشکلی رخ داده است.", "error");
    }

  }

  const swalPaymentHandeler = async (code) => {
    swal({
      title: "تسویه هزینه قطعه با پیمانکار مورد تایید است؟",
      icon: "warning",
      buttons: {
        cancel: "بازگشت",
        yes: "بله",
      },
      dangerMode: true,
    }).then((willPaid) => {
      if (willPaid) {
        accountSettlement(code);       
      }
    });
  }

  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس",
    },
    {
      field: null,
      text: "تصویر",
      element: (rowData) => (
        <ServiceImage rowData={rowData} scrollQuery="#div-content" />
      ),
    },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <ConstructionStatus rowData={rowData} />,
    },
    {
      field: null,
      text: "پیمانکار",
      element: (rowData) => <Contractor rowData={rowData} />,
    },
    {
      field: null,
      text: "فاز فعلی",
      element: (rowData) => rowData.current_phase ? <span>{rowData.current_phase.title}</span> : <span>مشخص نشده</span>,
    },
    {
      field: null,
      text: "مبلغ (تومان)",
      element: (rowData) => <Payment rowData={rowData} access={"manager"}/>,
    },
    {
      field: null,
      text: "تاریخ تحویل",
      element: (rowData) => <span>{convertDateToJalaali(rowData.preparation_date)}</span>,
    },
    {
      field: null,
      text: "جزییات",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            onClick={() =>
              window.open(
                `http://app.wisercam.com/DetailOrder/${rowData.code}`
              )
            }
          >
            مشاهده
          </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل مشتری",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithName(`${base_api_url}/shop_admin/get_customer_file/${rowData.code}/`, null, false);
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل نقشه",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithoutFormat(`${base_api_url}/shop_admin/get_local_customer_file/${rowData.code}/`)
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "توضیحات",
      element: (rowData) =>  <ManagerDetail rowData={rowData} iO={"m"} />
    },
    {
      field: null,
      text: "اختصاص پیمانکار",
      element: (rowData) =>  <ContractorAssignment rowData={rowData} />
    },
    {
      field: null,
      text: "کنترل کیفیت",
      element: (rowData) => <QualityControl rowData={rowData} />,
    },
    {
      field: null,
      text: "قابل مشاهده بودن",
      element: (rowData) => <Visibility rowData={rowData} />,
    },
    {
      field: null,
      text: "تسویه",
      element: (rowData) => {
        return (
            <IconButton
            disabled={!rowData.settlement_is_enable}
            sx={{ mx: "0.25rem" }}
            onClick={() => swalPaymentHandeler(rowData.code)}
            >
                <PaymentIcon className={rowData.settlement_is_enable ? "text-blue-500" : "text-gray-300"} />
            </IconButton>
        );
      },
    },
  ];

  return (
    <DataTablePagination
      tableCols={servicesCols}
      title={"مدیریت پیمانکاران"}
      APIFunction={getAllOrderedServiceForManagement}
      dataField={"services"}
      hasOutlet={true}
      hasCatergory={true}
      categoryOptions={options}
      forceRequest={forceRequest}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default ManageContractorServicePage;
